var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-pivottable',{attrs:{"data":_vm.fvalue,"rows":_vm.rows,"cols":_vm.cols,"aggregatorName":_vm.countType,"rendererName":_vm.type,"vals":_vm.vals}})
}
var staticRenderFns = []

export { render, staticRenderFns }